module.exports = __webpack_public_path__ + "static/media/project3.e12e3ac0.pdf";